<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1" id="Death_In_the_12th_House-6.html" xml:lang="en-US">
<div class="calibre1">
<p class="ct" id="toc_marker-7"><a href="#/OEBPS/Death_In_the_12th_House3#Contents-A">Epigraph</a></p>
<p class="quote">Grapes plucked from a nearly vacant vine<br class="calibre3"/>Quench better than the sweetest wine</p>
<p class="quote-by">—Marty Winebeck</p>
<p class="heading"></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Death_In_the_12th_House-6.vue?2465d6ae